/* global axios */
import ApiClient from './ApiClient';

class SupportIncidentsAPI extends ApiClient {
  constructor() {
    super('support_incidents', { accountScoped: true });
  }

  get({
    page = 1,
    status = '',
    severity = '',
    priority = '',
    flowStage = '',
    clinicAccountId = '',
    from = '',
    to = '',
    order = '',
  } = {}) {
    const params = new URLSearchParams({ page });
    if (status) params.append('status', status);
    if (severity) params.append('severity', severity);
    if (priority) params.append('priority', priority); // dropdown era MORTO: a tela enviava e o client descartava
    if (flowStage) params.append('flow_stage', flowStage);
    if (clinicAccountId) params.append('clinic_account_id', clinicAccountId);
    if (from) params.append('from', from);
    if (to) params.append('to', to);
    if (order) params.append('order', order);
    return axios.get(`${this.url}?${params.toString()}`);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { support_incident: data });
  }

  // contador leve pro badge da sidebar (erros pendentes: aberto + investigando)
  pendingCount() {
    return axios.get(`${this.url}/pending_count`);
  }

  // métricas do painel de Debug/Suporte (onde quebra, por clínica/DH, por dia, SLA)
  dashboard(days = 14) {
    return axios.get(`${this.url}/dashboard?days=${days}`);
  }

  // "avisar quem abriu" → manda o retorno pro atendente + carimba SLA de resposta
  acknowledge(id) {
    return axios.post(`${this.url}/${id}/acknowledge`);
  }

  // um incidente específico (deep-link do card do pipeline → ?incident=N)
  show(id) {
    return axios.get(`${this.url}/${id}`);
  }
}

export default new SupportIncidentsAPI();
